export const MENU_TOGGLE = 'menuToggle'
export const GET_MENU = 'getMenu'
export const GET_ROUTELIST = 'getRouteList'
export const LOGIN_OUT = 'loginOut'

export const GET_WZJK_LIST = 'getWzjkList' // 位置监控卡片列表
export const GET_VEHICLE_INFO = 'getVehicleInfo' // 获取所有车辆信息
export const GET_SELECCT_KEY = 'getSelectKey' // 获取当前选中的车
export const GET_CHANGE_LIST = 'getChangeList' // 获取更新的数据
